export default function ZoomEvent(target, type, transform) {
  this.target = target;
  this.type = type;
  this.transform = transform;
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-zoom/src/event.js
// module id = RIB7
// module chunks = 0